import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import Home from "./Pages/Home";
import Motorcyclestours from "./Pages/Motorcyclestours";
import Selfdrive from "./Pages/Selfdrive";
import Tourpackages from "./Pages/Tourpackages";
import Trekkingtours from "./Pages/Trekkingtours";
import Contactuss from "./Pages/Contactuss";
import Navbar from "./Components/Navbar/Navbar";
import Footer from "./Components/Footer/Footer";
import { Box } from "@mui/material";
import "./App.css"; 
import TourDetails from "./Pages/Tourdetails";
import { TourProvider } from "./Components/Data/Alldetails";
import Tourform from "./Pages/Tourform";
import { motion } from "framer-motion";
import BookingForm from "./Pages/Taxibookingform";
import BikeBookingSection from "./Pages/Bikebooking";
import WhatsAppWidget from "./Components/Whatsapp/WhatsappWidget";
import ScrollToTop from "./Components/UI/ScrollToTop";
import JammuKashmirPage from "./Pages/JammuKashmir";
import UttarakhandPage from "./Pages/Uk";
import LehLadakhPage from "./Pages/LadakhPage";
import HimachalPradeshPage from "./Pages/HimachalPage";
import SocialMediaComp from "./Components/FillerComponents/SocialMediaComp";

// Custom MUI Theme

const theme = createTheme({
  typography: {
    fontFamily: "Poppins, sans-serif", // Set global font family
    h1: { fontSize: "2.5rem", fontWeight: "bold" },
    h2: { fontSize: "2rem", fontWeight: "600" },
    h3: { fontSize: "1.75rem", fontWeight: "500" },
    h4: { fontSize: "1.5rem", fontWeight: "500" },
    h5: { fontSize: "1.25rem", fontWeight: "400" },
    h6: { fontSize: "1rem", fontWeight: "400" },
    AppBar:{borderRadius:'50px'},
    body1: { fontSize: "1rem", fontWeight: "400" },
    body2: { fontSize: "0.875rem", fontWeight: "300", color: "#555" }, // Slightly smaller & muted color
    button: {
      textTransform: "none", // Prevent automatic uppercase
      fontWeight: "bold",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "8px", // Rounded corners
          padding: "3px 8px",
          fontSize: "1rem",
          color:'white',
          fontFamily: "Poppins", // Set global font family
          fontWeight: "lighter",
        
        },
      },
    },
  },
});

function App() {
  return (
    <TourProvider>

    <ThemeProvider theme={theme}>
      <Router>
        <div className="App">
          <Box>
          
          <Box>
            <Navbar />
            
          </Box>
        <SocialMediaComp />
      <WhatsAppWidget />
      <ScrollToTop />

            <Box className="main-content">

              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/motorcylestours" element={<Motorcyclestours />} />
                <Route path="/tourdetails" element={<TourDetails />} />
                <Route path="/selfdrive" element={<Selfdrive />} />
                <Route path="/tourpackages" element={<Tourpackages />} />
                <Route path="/trekkingtours" element={<Trekkingtours />} />
                <Route path="/taxibooking" element={<BookingForm backgroundImage="https://content.jdmagicbox.com/v2/comp/delhi/k5/011pxx11.xx11.160607135419.g7k5/catalogue/badwal-taxi-services-safdarjung-enclave-delhi-car-rental-for-outstation-z1he0s2c6k.jpg"  />} />
                <Route path="/bikebooking" element={<BikeBookingSection backgroundImage="https://images.wanderon.in/blogs/new/2023/02/img_20210910_152040-1.jpg"  />} />
                <Route path="/contactuss" element={<Contactuss />} />
                <Route path="/jammu&kashmir" element={<JammuKashmirPage />} />
                <Route path="/leh&ladakh" element={<LehLadakhPage />} />
                <Route path="/himachalpradesh" element={<HimachalPradeshPage />} />
                <Route path="/uttarakhand" element={<UttarakhandPage />} />
                <Route path="/booking" element={<Tourform />} /> {/* Add the route for the form */}
              
              </Routes>
              
            </Box>
            <Footer />
          </Box>
        </div>
      </Router>
    </ThemeProvider>
    </TourProvider>
  );
  }
export default App;
